import { createReducer } from '@ngrx/store';

/* state key */
export const featureKey = 'SettingsDataStore';

/* state interface */
export interface SettingsState {
  usernameType: string;
  defaultModuleId: string;
  paymentProvider: string;
  isAuthenticationEnabled: boolean;
  homePageId: string;
  RAPIDER_AI_API_BASE_URL: string;
  apiBaseUrl: string;
  STAGE: string;
  production: boolean;
  PROJECT_ID: string;
  authenticateWithDescope: boolean;
  descopeProjectId: string;
  authenticateWithCredentials: boolean;
  DESCOPE_PROJECT_ID: string;
}

/* initial values */
export const initialState: SettingsState = {
  usernameType: 'email',
  defaultModuleId: 'd05af387-1961-4e48-94c4-8218c0f75c5c',
  paymentProvider: 'not-provided',
  isAuthenticationEnabled: true,
  homePageId: '21a1eba4-c175-4205-8b00-ed6a8c1e160c',
  RAPIDER_AI_API_BASE_URL: 'https://api.rapider.ai',
  apiBaseUrl: 'https://b713a217-f664-43a7-a6f6-fad732f4daa6.api.rappider.com',
  STAGE: 'DEV',
  production: false,
  PROJECT_ID: 'b713a217-f664-43a7-a6f6-fad732f4daa6',
  authenticateWithDescope: true,
  descopeProjectId: 'P2k10GWBu7QCAIowbm0wrqCLIVi7',
  authenticateWithCredentials: false,
  DESCOPE_PROJECT_ID: 'P2k10GWBu7QCAIowbm0wrqCLIVi7',
};

export const reducer = createReducer(initialState);
